/**
 * main.tsx — Vite/React entry point.
 *
 * Creates the React root, wraps <App/> in StrictMode and the
 * RootErrorBoundary (recovery screen, error persistence, localised
 * copy in 7 languages, "reset and reload" escape hatch).
 *
 * Loaded by index.html; mounts into #root.
 */
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { RootErrorBoundary } from './components/RootErrorBoundary.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <RootErrorBoundary>
      <App />
    </RootErrorBoundary>
  </StrictMode>,
)

// From here RootErrorBoundary owns render errors, and the boot guard in
// index.html stands down: an uncaught error in a handler must not wipe a
// working map (it did, on a walk link, 1 Oct 2026).
;(window as Window & { __fornlandMounted?: boolean }).__fornlandMounted = true

